let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kl2tC")).then(() => parcelRequire('lTYfI'));